import loadable from '@loadable/component';
import storePageQuery from './query.graphql';

const StorePage = loadable(() =>
  import(/* webpackChunkName: "store" */ './store')
);

StorePage.graphQL = storePageQuery;

StorePage.variables = ({ id, offset, section, notification, filter }) => ({
  id,
  offset: parseInt(offset, 10) || 0,
  section,
  // Invalidate store reviews cache if anonymous review was verified
  invalidateCache:
    notification === 'verify-success' || notification === 'delete-success',
  filter,
});

StorePage.loadOrder = [{}];

export default StorePage;
